<template>
    <div :class="['status-icon', 'status-' + colorScheme]">
        <div>
            <span class="material-icons" style="vertical-align: middle;">{{ icon }}</span>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        colorScheme: {
            type: String
        },
        icon: {
            type: String,
            required: true
        }
    }
}
</script>

<style lang="scss" scoped>
    .status-icon {
        color: #666;

         & > div {
            padding: .5rem;
            background: #eeeeee;
            border-radius: 5px;

            .material-icons {
                font-size: 30px;
            }
        }

        &.status-success {
            color: #155724;
            & > div {
                background: #d4edda;
            }
        }

        &.status-info {
            color: #084298;
            & > div {
                background: #cfe2ff;
            }
        }

        &.status-warning {
            color: #664d03;
            & > div {
                background: #fff3cd;
            }
        }

        &.status-error {
            color: #842029;
            & > div {
                background: #f8d7da;
            }
        }
    }
</style>